const SHOW_MODAL = 1
const HIDE_MODAL = 0


const ModalWrapperReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case SHOW_MODAL:
            return {
                show: true,
                ...payload
            };
        case HIDE_MODAL:
            return {
                show: false,
                ...payload
            };
        default:
            return state;
    }
};

export default ModalWrapperReducer;
